<template>
  <div>
    <search-carrier-account @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="isShowSupplierNewModal = true" v-if="isShowMenu('carrier_accounts/new')">新增供应商</a-button>
        <a-button type="primary" @click="isShowNewModal = true" v-if="isShowMenu('carrier_accounts/new')">新增账户</a-button>
        <destroy-carrier-account
          v-if="isShowMenu('carrier_accounts/delete')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      @change="sortChange"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >

      <div slot="name" slot-scope="name, record">
        <div v-if="isShowMenu('carrier_accounts/show')">
          <router-link :to="{ name: 'carrier_account_info', params: { id: record.id }}"> {{ name }} </router-link>
        </div>
        <div v-else> {{ name }} </div>
      </div>

      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record.id)" v-if="isHasEditPermission">编辑</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 新增供应商账户模态框 -->
    <new-supplier-account
      v-if="isShowSupplierNewModal"
      :visible.sync="isShowSupplierNewModal"
    />

    <!-- 新增运营商账户模态框 -->
    <new-carrier-account
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <!-- 编辑用户模态框 -->
    <edit-carrier-account
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />
  </div>

</template>

<script>
import { findCarrierAccounts, exportCarrierAccounts } from '@/api/carrier_account'
import Pagination from '@/components/Pagination/index'
import SearchCarrierAccount from '@/views/carrier_accounts/Search'
import { hasPermission } from '@/utils/permission'
import { exportExcel } from '@/api/excel'

export default {
  name: 'CarrierAccountList',
  components: {
    Pagination,
    SearchCarrierAccount,
    NewSupplierAccount: () => import('@/views/carrier_accounts/SupplierNew'),
    NewCarrierAccount: () => import('@/views/carrier_accounts/New'),
    EditCarrierAccount: () => import('@/views/carrier_accounts/Edit'),
    DestroyCarrierAccount: () => import('@/views/carrier_accounts/Destroy')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowSupplierNewModal: false,
      isShowNewModal: false,
      isShowEditModal: false,
      selectedRowKeys: [],
      editingId: 0, // 正在编辑的记录id
      pagination: {
        total_count: 0
      },
      query: {},
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '运营商账户',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '运营商种类',
          dataIndex: 'carrier_type'
        },
        {
          title: '卡号总数（不含销卡）',
          dataIndex: 'card_count'
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          sorter: true,
          sortOrder: this.sort.sort_field === 'created_at' ? this.sort.sort_order : false
        },
        {
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    },

    isHasEditPermission() {
      return hasPermission('carrier_accounts/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showEditModal(carrierAccountId) {
      this.editingId = carrierAccountId
      this.isShowEditModal = true
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findCarrierAccounts(Object.assign({}, this.query, this.sort)).then((res) => {
        this.data = res.data
        this.pagination.total_count = res.pagination.total_count
        this.loading = false
      })
    },
    exportData() {
      exportCarrierAccounts(Object.assign({}, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>
